import React from 'react';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export const GuaranteeSection = () => {
  return <section className="bg-gradient-to-b from-teal-800 to-teal-700 text-white py-12" data-id="element-165">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-166">
        <div className="bg-white bg-opacity-10 p-6 rounded-lg border border-teal-400 max-w-2xl mx-auto" data-id="element-167">
          <div className="flex items-center justify-center mb-4" data-id="element-168">
            <ShieldCheckIcon className="w-10 h-10 text-teal-300 mr-3" data-id="element-169" />
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-170">
              Try It Risk-Free for 30 Days
            </h2>
          </div>
          <p className="text-center text-lg mb-4" data-id="element-171">
            If you don't feel a difference in your nervous system after
            completing the program, we'll refund your full payment—no questions
            asked.
          </p>
          <div className="flex items-center justify-center" data-id="element-172">
            <LockIcon className="w-5 h-5 text-teal-300 mr-2" data-id="element-173" />
            <p className="text-sm text-teal-200" data-id="element-174">
              Secure, protected guarantee. We honor our word.
            </p>
          </div>
        </div>
      </div>
    </section>;
};